import MyData from './MyData'
import './MyData.css'

export default MyData



// WEBPACK FOOTER //
// ./src/features/Personal/containers/MyData/index.js